/* eslint-disable import/prefer-default-export */
import { RefObject, useEffect } from "react";
import { sendCtrEvent, CtrEventProps } from "./clickThroughRateHelpers";

export const useCtrImpressionTracking = (
  divRef: RefObject<HTMLDivElement>,
  CtrEventProps: CtrEventProps
) => {
  const { destination, source, type } = CtrEventProps;
  useEffect(() => {
    const currentRef = divRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            sendCtrEvent("Impression", { destination, source, type });
            observer?.disconnect();
          }
        });
      },
      { threshold: 0.75 }
    );

    if (currentRef && source && type) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [divRef, destination, source, type]);
};
